import ni from '../data/node-index';

let indexDelete = {
  exeDelete : node=>{
    let $delete = $('.ui-node-delete');
    if(!$delete.length){
      $delete = $(`<div class="ui-node-delete ui-modal">
        <span class="modal-close">&times;</span>
        <h5>type 'DELETE' to delete index. There is no undo</h5>
        <input type="text" maxlength="25" placeholder="">
        <button type="button">OK</button>
      </div>`);
      $delete.find('.modal-close').click(()=>{
        $delete.hide()
      });
      $('body').append($delete);
    }else{
      $delete.find('input[type=text]').val('');
      $delete.show();
    }
    $delete.find('button').off('click').on('click', ()=>{
      ($delete.find('input[type=text]').val() === 'DELETE') && ni.delete(node);
      $delete.hide();
    });
  }
}

export default indexDelete;


// WEBPACK FOOTER //
// ./src/scripts/ui/index-delete.js